import React, { useState, useEffect } from "react";
import FormItem from "../FormItem";
import makeLinelayout from "./layout";
import * as TUI from "../../index";
import "./index.less";
const colVisible = (rule, fields) => {
  if (typeof rule.visible !== "function") return true;
  return rule.visible({ fields });
};

const lineVisible = (line = [], schema, fields) => {
  let visibleCount = line.length;
  for (let field of line) {
    const rule = schema[field];
    if (!colVisible(rule, fields)) {
      visibleCount--;
    }
  }
  return !!visibleCount;
};

const lineError = (line, errors) => {
  const errorTip = line.reduce((p, c) => p || errors[c], "");
  return errorTip;
};
const lineStatus = (line, errors, schema) => {
  for (var c of line) {
    if ("validateStatus" in schema[c]) {
      return schema[c].validateStatus;
    }
  }
  var e = line.reduce((p, c) => p || errors[c], "");
  return !!e ? "error" : "";
};

const lineHelp = (line, schema) => {
  const helpTip = line.reduce((p, c) => p || schema[c].help, "");
  return helpTip;
};

const colRequired = (rule) => {
  return (rule.rules || []).reduce((p, c) => p || !!c.required, false);
};
const lineRequired = (line, schema) => {
  return line.reduce((p, c) => p || colRequired(schema[c]), false);
};

const firstField = (line) => {
  const [firstField] = line;
  return firstField;
};
const lineName = (line, schema) => {
  let first = firstField(line);
  return schema[first].name;
};
const DefaultLayout = ({children}) => children;
export default function Form({
  fields = {},
  onFieldChange,
  onChange,
  schema,
  errors = {},
  children,
  Layout = DefaultLayout,
  hideLabel,
  className
}) {
  const schemaLayout = makeLinelayout(schema);
  return (
    <div className={["TUI-Form", className].filter(d => !!d).join(" ")}>
      <Layout>
      {schemaLayout.map((line) => {
        if (!lineVisible(line, schema, fields)) return null;
        return (
          <FormItem
            key={"line-" + firstField(line)}
            label={hideLabel ? null : lineName(line, schema)}
            validateStatus={lineStatus(line, errors, schema)}
            help={
              (lineStatus(line, errors, schema) === "error"
                ? lineError(line, errors)
                : "") || lineHelp(line, schema)
            }
            required={lineRequired(line, schema)}
          >
            {line.map((field) => {
              const rule = schema[field];
              const ItemType = typeof rule.type === "string" ? TUI[rule.type] : rule.type;
              if (!colVisible(rule, fields)) return null;
              let disabled = false;
              if (rule.opts && rule.opts.disabled) {
                const { disabled: temp } = rule.opts;
                disabled = typeof temp === "function" ? temp(fields) : temp;
              }
              return (
                <ItemType
                  key={field}
                  name={field}
                  value={fields[field]}
                  placeholder={rule.placeholder}
                  fields={fields}
                  options={
                    rule.optionCompute
                      ? rule.optionCompute(fields, rule.options)
                      : rule.options
                  }
                  onChange={(value) => {
                    if (rule.opts && rule.opts.handleChange) {
                      rule.opts.handleChange(value, onChange);
                    } else {
                      onFieldChange(field, value);
                    }
                  }}
                  opts={{ ...rule.opts, disabled }}
                />
              );
            })}
          </FormItem>
        );
      })}
      {children}
      </Layout>
    </div>
  );
}
